import React from "react";
import Meta from "../components/Meta";

const AdvertiseWithUsPage = () => {
  return (
    <>
     <Meta title="Welcome To E-Blog" />
      <div className="alert alert-info p-5">
        <div className="d-flex justify-content-center p-5">
          <h1>Advertise With Us</h1>
        </div>
      </div>
      <hr />
      <div>
        <p className="text-justify">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam nemo id,
          accusamus molestias maxime vero laudantium placeat repellendus labore
          vel magni est quas fugit impedit quasi laboriosam quae animi. Iusto
          minus perferendis quae magnam, maxime, dolore molestiae sunt quos cum,
          ipsum sint ipsa. Aperiam, suscipit incidunt molestiae natus rem
          soluta! Ad consequatur, esse quo culpa, at nisi animi provident
          molestias ex laudantium sunt harum, qui reprehenderit quae eveniet in.
          Dolorum vel quam quaerat, sunt neque dicta voluptates officia odit
          enim molestiae error sint, ipsa reprehenderit accusamus id provident
          commodi asperiores nihil magni. Quod ullam aperiam incidunt mollitia
          vel voluptatum libero beatae dolorum impedit. Tempora alias id ipsa?
          Accusamus, veritatis tempore. Nostrum explicabo saepe optio, quibusdam
          nemo dolore iure impedit pariatur nam excepturi accusamus nisi facilis
          quos harum molestiae commodi perspiciatis aperiam iusto facere modi
          mollitia rerum doloribus? Distinctio unde cumque, sit ab alias vitae
          aspernatur accusamus dolorum voluptatum labore quia cupiditate nostrum
          commodi quos nemo id dicta itaque est quae repellat quas rem autem
          deleniti optio. Obcaecati excepturi animi vero aliquid. Iste,
          architecto adipisci sapiente excepturi quam, quia autem, sequi enim
          quibusdam nihil id accusantium. Dolores, architecto! Dolores hic
          asperiores labore, explicabo repellat ut praesentium ab tempore. Animi
          culpa est dolores, qui modi blanditiis veniam vel et consequuntur
          commodi odio libero? Libero repudiandae eum cumque nihil voluptas
          deserunt dolores voluptates corrupti praesentium, quae illo ad
          doloremque voluptatibus magnam. Soluta perspiciatis nemo consequatur
          voluptatem eaque sapiente omnis, veritatis cumque ex. Illo saepe vero
          sequi possimus nostrum error? Ab quia velit recusandae molestiae modi
          maxime ex nihil ullam unde. Eveniet, minima fuga quis ea quae
          necessitatibus odio doloremque vel rem omnis quidem tempora officia
          asperiores itaque ducimus ut esse quos, quod consectetur eum illo
          distinctio ex voluptate hic! Explicabo voluptates distinctio mollitia
          itaque debitis exercitationem qui eveniet nemo odio? Fugiat, unde
          soluta.
        </p>
      </div>
    </>
  );
};

export default AdvertiseWithUsPage;
